module.exports = __webpack_public_path__ + "img/trainer3.bf9619d1.jpg";